// MOCK DATA for Cali Boyz store (frontend-only teaser)
export const TELEGRAM_URL = 'https://t.me/+2oyObP9EyZZkNTE0';
export const INSTAGRAM_URL = 'https://instagram.com';
export const TIKTOK_URL = 'https://tiktok.com';

export const CATEGORIES = [
  { slug: 'all', name: 'Wszystkie' },
  { slug: 'zelki', name: 'Żelki THC' },
  { slug: 'czekoladki', name: 'Czekoladki' },
  { slug: 'syropy', name: 'Syropy' },
  { slug: 'herbaty', name: 'Herbaty' },
  { slug: 'shoty', name: 'Shoty' },
  { slug: 'tabletki', name: 'Tabletki' },
  { slug: 'conez', name: 'Cali Conez' },
];

export const PRODUCTS = [
  {
    id: 'conez-nutella-150',
    name: 'Cali Conez Nutella Flavor 150MG',
    subtitle: '5 rożków po 30MG',
    category: 'conez',
    price: 179.99,
    oldPrice: null,
    thc: '150MG',
    image: '/products/prod-cali-conez-nutella.jpg',
    inStock: true,
    badge: 'NOWOŚĆ',
    rating: 4.9,
    reviews: 42,
    description: 'Kremowy smak Nutelli w chrupiących rożkach. Pięć porcji po 30MG THC — idealne na powolne, przyjemne doznanie. Kokos i orzech, który robi robotę!'
  },
  {
    id: 'cali-pine-50',
    name: 'Cali Pine 50MG THC',
    subtitle: 'szyszka w karmelu',
    category: 'zelki',
    price: 89.99,
    oldPrice: null,
    thc: '50MG',
    image: '/products/pine.webp',
    inStock: false,
    badge: 'WKRÓTCE',
    rating: 5.0,
    reviews: 7,
    description: 'Szumi las, że szyszki lecą! Karmelowa szyszka 50MG THC. Wkrótce dostępna — zapisz się do newslettera, by nie przegapić premiery.'
  },
  {
    id: 'czekoladki-450',
    name: 'Czekoladki THC 150mg 3szt.',
    subtitle: 'łącznie 450mg',
    category: 'czekoladki',
    price: 149.98,
    oldPrice: 169.99,
    thc: '450MG',
    image: '/products/prod-cali-czekolada.jpg',
    inStock: true,
    badge: 'PROMO',
    rating: 4.8,
    reviews: 128,
    description: 'Trzy premium czekoladki po 150mg THC. Najwyższa jakość kakao i sprawdzone składniki. Mocne i długotrwałe doznanie w słodkiej formie.'
  },
  {
    id: 'syrop-helena-1000',
    name: 'Syrop Oranżada Helena 1000mg',
    subtitle: 'magiczny syrop',
    category: 'syropy',
    price: 199.99,
    oldPrice: 224.99,
    thc: '1000MG',
    image: '/products/prod-syrop-helena.jpg',
    inStock: true,
    badge: 'PROMO',
    rating: 4.9,
    reviews: 96,
    description: 'Legendarny smak oranżady w mocnej wersji 1000mg THC. Dozuj wedle uznania — mix z ulubionym napojem gwarantuje niepowtarzalny efekt.'
  },
  {
    id: 'tabletki-250',
    name: 'Tabletki THC 250mg 2szt.',
    subtitle: '2 tabletki po 125mg',
    category: 'tabletki',
    price: 99.99,
    oldPrice: 129.00,
    thc: '250MG',
    image: '/products/prod-tabletki-250mg.jpg',
    inStock: true,
    badge: 'PROMO',
    rating: 4.7,
    reviews: 63,
    description: 'Precyzyjnie odmierzona dawka w wygodnej formie. Dwie tabletki 250mg THC — dyskretne, mocne i szybkie w działaniu.'
  },
  {
    id: 'tabletki-500',
    name: 'Tabletki THC 500mg 2szt.',
    subtitle: '2 tabletki po 250mg',
    category: 'tabletki',
    price: 149.99,
    oldPrice: 199.00,
    thc: '500MG',
    image: '/products/prod-tabletki-500mg.jpg',
    inStock: true,
    badge: 'BESTSELLER',
    rating: 4.9,
    reviews: 154,
    description: 'Dla doświadczonych. Dwie tabletki 500mg THC dają naprawdę mocne i długotrwałe doznanie. Tylko dla tych, którzy wiedzą co robią.'
  },
  {
    id: 'zelki-500',
    name: 'Żelki THC 500mg 5szt.',
    subtitle: '5 żelków po 100mg',
    category: 'zelki',
    price: 179.99,
    oldPrice: 189.99,
    thc: '500MG',
    image: '/products/prod-zelki-500mg.jpg',
    inStock: true,
    badge: 'BESTSELLER',
    rating: 5.0,
    reviews: 211,
    description: 'Nasze flagowe żelki THC. Pięć owocowych żelków po 100mg — najlepszy stosunek smaku do mocy. Edibless nr 1!'
  }
];

export const FEATURES = [
  { icon: 'Leaf', title: 'PREMIUM JAKOŚĆ THC', text: 'Tylko sprawdzone składniki i najwyższa jakość.' },
  { icon: 'Droplet', title: 'NATURALNE SKŁADNIKI', text: 'Wykorzystujemy to, co daje natura.' },
  { icon: 'Box', title: 'MOCNE I DŁUGOTRWAŁE DOZNANIA', text: 'Produkty stworzone z myślą o wyjątkowym efekcie.' },
  { icon: 'Crown', title: 'STYL ŻYCIA CALI BOYZ', text: 'To nie tylko produkty, to styl życia.' }
];

export const HIGHLIGHTS = [
  { icon: 'Leaf', label: 'JAKOŚĆ.' },
  { icon: 'Droplet', label: 'MOC.' },
  { icon: 'Box', label: 'DOZNANIA.' }
];

export const GALLERY = [
  '/products/prod-cali-czekolada.jpg',
  '/products/conez.webp',
  '/products/syrop2.webp',
  '/products/prod-zelki-500mg.jpg',
  '/products/prod-tabletki-500mg.jpg',
  '/products/prod-syrop-helena.jpg',
  '/products/prod-tabletki-250mg.jpg',
  '/products/pine.webp'
];

export const FAQS = [
  { q: 'Jak złożyć zamówienie?', a: 'Dodaj produkty do koszyka, przejdź do podsumowania i kliknij „Zamów na Telegramie”. Wygenerujemy gotową wiadomość z Twoim zamówieniem — wyślij ją do nas, a resztę ustalimy na czacie.' },
  { q: 'Czy muszę mieć ukończone 18 lat?', a: 'Tak. Nasze produkty przeznaczone są wyłącznie dla osób pełnoletnich (18+). Przy wejściu na stronę potwierdzasz swój wiek.' },
  { q: 'Jak działają produkty THC w formie jadalnej?', a: 'Efekt pojawia się wolniej niż przy paleniu (30–90 min) i utrzymuje się dłużej. Zacznij od małej dawki, zwłaszcza jako początkujący.' },
  { q: 'Jakie są metody płatności?', a: 'Szczegóły płatności i dostawy ustalamy indywidualnie na Telegramie po złożeniu zamówienia.' },
  { q: 'Czy jest rabat na kolejne zamówienie?', a: 'Tak! Zostaw opinię po zakupie, a na następne zamówienie otrzymasz 15% rabatu. Zapisz się też do newslettera po kody rabatowe.' },
  { q: 'Co polecacie dla początkujących?', a: 'Świetnym startem są Żelki THC 500mg (dawkuj po jednym) oraz Cali Conez. Dają łagodne, przyjemne wejście.' }
];

export const REVIEWS = [
  { name: 'Kuba M.', rating: 5, text: 'Żelki mocne jak diabli, smak rewelacyjny. Zamawiam po raz trzeci!', product: 'Żelki THC 500mg' },
  { name: 'Ola W.', rating: 5, text: 'Syrop Helena to klasyk. Oranżada + moc = ideał. Polecam!', product: 'Syrop Oranżada Helena' },
  { name: 'Marek T.', rating: 4, text: 'Tabletki 500mg naprawdę dają radę. Dla doświadczonych — działa długo.', product: 'Tabletki THC 500mg' },
  { name: 'Natalia K.', rating: 5, text: 'Conez Nutella — smak z dzieciństwa, ale w wersji dla dorosłych. Bomba.', product: 'Cali Conez Nutella' }
];
